// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__3-r5+","left":"PageHeader_left__4+9ko","title":"PageHeader_title__pRoV8","subtitle":"PageHeader_subtitle__xg6ur","actions":"PageHeader_actions__VD5gC"};